import React from "react";
import { PiKeyboard, PiVideo, PiDownloadBold } from "react-icons/pi";
import { RiAiGenerate } from "react-icons/ri";
import { FaQuestionCircle, FaInfinity, FaRobot, FaBookOpen } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import '../../i18n'; // Import the i18n configuratio
const SlideThree = () => {
    const { t, i18n } = useTranslation();

    return (
        <div className="dark:bg-black">
            <div className="flex items-center justify-center text-center">
                <div className="text-4xl font-black dark:text-white max-md:text-2xl">{t('how_it_works')}</div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-24 max-md:py-14 text-center">
                {/* <div className="flex flex-col items-center justify-center">
                    <FaQuestionCircle className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_1')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_1')}</div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <RiAiGenerate className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_2')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_2')}</div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <FaRobot className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_3')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_3')}</div>
                </div> */}

                <div className="flex flex-col items-center justify-center">
                    <PiDownloadBold className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_1')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_1')}</div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <FaQuestionCircle className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_2')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_2')}</div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <FaBookOpen className="text-4xl max-md:text-3xl dark:text-white" />
                    <div className="text-2xl max-md:text-lg pt-4 font-bold dark:text-white">{t('work_title_3')}</div>
                    <div className="text-lg max-md:text-xs text-center px-3 pt-2 font-medium dark:text-white">{t('work_description_3')}</div>
                </div>
            </div>
        </div>
    );
};

export default SlideThree;
